import { QueryParamsModel } from '../../_base/crud/models/query-models/query-params.model';
import { forkJoin } from 'rxjs';
import { Injectable } from '@angular/core';
import { mergeMap, map, tap, delay } from 'rxjs/operators';
import { Effect, Actions, ofType } from '@ngrx/effects';
import { Store } from '@ngrx/store';
import { QueryResultsModel } from '../../_base/crud';
import { RecordsService } from '../_services';
import { AppState } from '../../reducers';
import {

    RecordActionToggleLoading,
    RecordActionTypes,
    RecordsPageLoaded,
    RecordsPageRequested,
    BqRecordsPageRequested,
    ScoringRecordPageRequested,
   TriggerPageRequested,

    RecordsPageToggleLoading,
    OneRecordDeleted,
    RecordOnServerCreated,
    RecordCreated,
    RecordUpdated,
    RecordUpdated2,
    BqRecordsPageLoaded,
    ScoringRecordPageLoaded,
   TriggerPageLoaded


} from '../_actions/Record.actions';
import { of } from 'rxjs';

@Injectable()
export class RecordEffects {
    showPageLoadingDistpatcher = new RecordsPageToggleLoading({ isLoading: true });
    showActionLoadingDistpatcher = new RecordActionToggleLoading({ isLoading: true });
    hideActionLoadingDistpatcher = new RecordActionToggleLoading({ isLoading: false });

    @Effect()
    loadRecordsPage$ = this.actions$.pipe(
        ofType<RecordsPageRequested>(RecordActionTypes.RecordsPageRequested),
        mergeMap(( { payload } ) => {
            this.store.dispatch(this.showPageLoadingDistpatcher);
            const requestToServer = this.RecordsService.findRecords(payload.page);            
            const lastQuery = of(payload.page);
            return forkJoin(requestToServer, lastQuery);
        }),
        map(response => {
            const result: QueryResultsModel = response[0];
            const lastQuery: QueryParamsModel = response[1];
            const pageLoadedDispatch = new RecordsPageLoaded({
                Records: result
            });
            return pageLoadedDispatch;
        })
    );

    @Effect()
    loadBqRecordsPage$ = this.actions$.pipe(
        ofType<BqRecordsPageRequested>(RecordActionTypes.BqRecordsPageRequested),
        mergeMap(( { payload } ) => {
            this.store.dispatch(this.showPageLoadingDistpatcher);
            const requestToServer = this.RecordsService.findRecords(payload.page);            
            const lastQuery = of(payload.page);
            return forkJoin(requestToServer, lastQuery);
        }),
        map(response => {
            const result: QueryResultsModel = response[0];            
            const lastQuery: QueryParamsModel = response[1];
            const pageLoadedDispatch = new BqRecordsPageLoaded({
                Records: result
            });
            return pageLoadedDispatch;
        })
    );
    @Effect()
    loadScoringRecordPageScoring$ = this.actions$.pipe(
        ofType<ScoringRecordPageRequested>(RecordActionTypes.ScoringRecordPageRequested),
        mergeMap(( { payload } ) => {
            this.store.dispatch(this.showPageLoadingDistpatcher);
            const requestToServer = this.RecordsService.findRecords(payload.page);            
            const lastQuery = of(payload.page);
            return forkJoin(requestToServer, lastQuery);
        }),
        map(response => {
            const result: QueryResultsModel = response[0];            
            const lastQuery: QueryParamsModel = response[1];
            const pageLoadedDispatch = new ScoringRecordPageLoaded({
                Records: result
            });
            return pageLoadedDispatch;
        })
    );
    @Effect()
    loadScoringRecordPagetrigger$ = this.actions$.pipe(
        ofType<TriggerPageRequested>(RecordActionTypes.TriggerPageRequested),
        mergeMap(( { payload } ) => {
            this.store.dispatch(this.showPageLoadingDistpatcher);
            const requestToServer = this.RecordsService.findRecords(payload.page);            
            const lastQuery = of(payload.page);
            return forkJoin(requestToServer, lastQuery);
        }),
        map(response => {
            const result: QueryResultsModel = response[0];            
            const lastQuery: QueryParamsModel = response[1];
            const pageLoadedDispatch = new TriggerPageLoaded({
                Records: result
            });
            return pageLoadedDispatch;
        })
    );
    @Effect()
    deleteCustomer$ = this.actions$
        .pipe(
            ofType<OneRecordDeleted>(RecordActionTypes.OneRecordDeleted),
            mergeMap(( { payload } ) => {
                    this.store.dispatch(this.showActionLoadingDistpatcher);
                    return this.RecordsService.deleteRecord(payload.id);
                }
            ),
            map(() => {
                return this.hideActionLoadingDistpatcher;
            }),
        );

        @Effect()
        createRecord$ = this.actions$
            .pipe(
                ofType<RecordOnServerCreated>(RecordActionTypes.RecordOnServerCreated),
                mergeMap(( { payload } ) => {
                    this.store.dispatch(this.showActionLoadingDistpatcher);
                    return this.RecordsService.createRecord(payload.Record).pipe(
                        tap(res => {
                            this.store.dispatch(new RecordCreated({ Record: res }));
                        })
                    );
                }),
                map(() => {
                    return this.hideActionLoadingDistpatcher;
                }),
            );

            @Effect()
            updateToggel$ = this.actions$
                .pipe(
                    ofType<RecordUpdated>(RecordActionTypes.RecordUpdated),
                    mergeMap(( { payload } ) => {                        
                        this.store.dispatch(this.showActionLoadingDistpatcher);
                        this.RecordsService.updateRecord(payload.Record);
                        return this.RecordsService.updateRecord(payload.Record);
                    }),
                    map(() => {
                        return this.hideActionLoadingDistpatcher;
                    })
                );
                @Effect()

                updateToggel2$ = this.actions$
                .pipe(
                    ofType<RecordUpdated2>(RecordActionTypes.RecordUpdated2),
                    mergeMap(( { payload } ) => {                                                
                        this.store.dispatch(this.showActionLoadingDistpatcher);
                        this.RecordsService.updateRecord2(payload.Record,payload.type);
                        return this.RecordsService.updateRecord2(payload.Record,payload.type);
                    }),
                    map(() => {
                        return this.hideActionLoadingDistpatcher;
                    })
                );
    constructor(private actions$: Actions, private RecordsService: RecordsService, private store: Store<AppState>) { }

}
